import {useStores} from 'hooks/useStores';
import {AccessControl} from 'modules/rbac';
import {useFeatureFlag, LD_FLAGS} from 'modules/feature-flags';
import {staffListColumns} from './columns';

type Params = {
  isMobile: boolean;
};

export const useStaffListColumns = ({isMobile}: Params) => {
  const {meStore, RBACStore} = useStores();
  const emrManagedUsers = useFeatureFlag(LD_FLAGS.EMR_MANAGED_USERS);

  const columns = isMobile
    ? [staffListColumns.mobile]
    : [staffListColumns.name, staffListColumns.role];

  if (!isMobile) {
    if (RBACStore.hasAccess(AccessControl.staff.viewListProgress)) {
      columns.push(staffListColumns.lastLogin);
    }

    columns.push(staffListColumns.programs);

    if (meStore.ehrIntegrationOption) {
      columns.push({
        ...staffListColumns.ehr,
        headerName: meStore.ehrIntegrationOption?.name || 'EHR System',
      });
    }
  }

  if (
    RBACStore.hasAccess(AccessControl.staff.viewListActions) &&
    !emrManagedUsers
  ) {
    columns.push(staffListColumns.actions);
  }

  return columns;
};
